export enum STATUS {
  NEW,
  UPLOADING,
  FAILURE,
  DONE,
}

export interface UploadResource {
  uid: string;
  size: number;
  name: string;
  url: string;
  status: STATUS;
  progress: number;
  file: File;
  description: string;
  tags: string[];
  link: string;
  ossFile?: IPinFile & {
    aigc?: {
      aigc_category?: string;
      prompt?: string;
    };
  };
  failMsg?: string;
}
